import { useEffect, useState } from "react";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import { createAuthApi } from "@/shell-handle/auth";

export const useUser = () => {
  const host = useShellHost();
  const [user, setUser] = useState(host.handle.auth.currentUser.get());

  useEffect(() => {
    setUser(host.handle.auth.currentUser.get());
    return host.handle.auth.currentUser.subscribe(setUser);
  }, [host]);

  const signOut = async () => {
    // Go through the shell's auth api, not amplify directly, so the sign-out is
    // classified as deliberate and does not leave a returnTo behind for the
    // next user.
    await createAuthApi().signOut();
    host.setCurrentUser(null);
    window.location.assign("/login");
  };

  return { user, signOut };
};
